import * as React from 'react';

import { ApolloError } from 'apollo-client';
/* eslint-disable */
import cx from 'classnames';
import { OrganizationType } from 'globalTypes';
import { debounce, isNil, throttle } from 'lodash';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import ReactDOM from 'react-dom';

// @ts-ignore
import ErrorActions from 'actions/ErrorActions';
// @ts-ignore
import ToastActions from 'actions/ToastActions';
import CurrentUser from 'auth/CurrentUser';
import Groups from 'collections/Groups';
import Organizations from 'collections/Organizations';
import Teachers from 'collections/Teachers';
import AlertDialog from 'components/AlertDialog';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import ConfirmDialog from 'components/ConfirmDialog';
import Dialog from 'components/Dialog';
import DialogContent from 'components/DialogContent';
import FormElement from 'components/FormElement';
import Glyph from 'components/Glyph';
import HelpIcon from 'components/HelpIcon';
import Input from 'components/Input';
import Label from 'components/Label';
import Link from 'components/Link';
import LoadingIndicator from 'components/LoadingIndicator';
import MediaObject from 'components/MediaObject';
import NameAndSignatureQuery from 'components/NameAndSignatureQuery';
import PrependedTextInput from 'components/PrependedTextInput';
import Row from 'components/Row';
import ScrollableArea from 'components/ScrollableArea';
import StatusLabel from 'components/StatusLabel';
import Text from 'components/Text';
import KeyConstants from 'constants/KeyConstants';
import LinkConstants from 'constants/LinkConstants';
import Group from 'entities/Group';
import Organization from 'entities/Organization';
import Teacher from 'entities/Teacher';
import GroupActions from 'groups/actions/GroupActions';
import GroupAvatar from 'groups/components/GroupAvatar';
import GroupName from 'groups/components/GroupName';
import { loadGQLUserGroupByCode, loadNonV2GroupByCode } from 'groups/lib/GroupPromises';
import JoinInfoModal from 'join/components/JoinInfoModal';
import assertions from 'lib/assertions';
import enumerate from 'lib/enumerate';
import { mountModal } from 'lib/modal';
import BirthdayInterruptModal from 'setup/components/BirthdayInterruptModal';
// @ts-ignore
import ReportTeacherSelectModal from 'support/components/ReportTeacherSelectModal';
// @ts-ignore
import UserActions from 'user/UserActions';
import errorLogger from 'utils/errorLogger';
import getRedirectLocationAfterGroupJoin from 'utils/getRedirectLocationAfterGroupJoin';

import JoinGroupModalRequestToJoin from './JoinGroupModalRequestToJoin';

import { cancelGroupMembershipRequestVariables } from 'groupMembershipRequests/containers/mutations/__generated__/cancelGroupMembershipRequest';
import { KeyboardEventHandler } from 'types/typescript/eventHandlers';

import CANCEL_REQUEST from 'groupMembershipRequests/containers/mutations/CancelGroupMembershipRequest.gql';

import './styles/JoinGroupModal.scss';

const DEBOUNCE_DELAY = 300;
const ORGANIZATIONS_PAGE_SIZE = 20;

const STATUS = enumerate([
  'JOIN_CLASS',
  'FIND_SCHOOL',
  'FIND_TEACHER',
  'SELECT_CLASS',
  'REQUEST_TO_JOIN_CLASS',
]);

type RequestToJoinGroup = {
  className: string;
  code: string;
  organization: { name: string } | null;
  groupAvatar: { svg_url: string } | null;
};

type Props = {
  footer?: any | null;
  modal?: boolean;
  onRequestHide: () => void;
  onJoin: (group: Group) => void;
};

type State = {
  teachers: Teachers | null;
  groupCode?: string;
  joinEnabled: boolean;
  status: any;
  highlight: number;
  organization: Organization | null;
  loadingOrganizations: boolean;
  errorMessage: string | null;
  organizationQuery: string;
  allOrganizationsLoaded: boolean;
  organizations: Organizations | null;
  teacherQuery: string;
  loadingTeachers: boolean;
  teacher: Teacher | null;
  loadingGroups: boolean;
  groups: Groups | null;
  rtjGroup?: RequestToJoinGroup;
};

// XXX too big, break apart
class JoinGroupModal extends React.Component<Props, State> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  static defaultProps = {
    footer: null,
    modal: true,
  };

  childRefs: {
    scrollAreaOrganizations: React.RefObject<ScrollableArea>;
    scrollAreaTeachers: React.RefObject<ScrollableArea>;
    groupCode: React.RefObject<HTMLInputElement>;
    scrollAreaGroups: React.RefObject<ScrollableArea>;
  };

  constructor(props: Props) {
    super(props);
    this._blockResultMouseOverWhileScrolling = false;

    this.state = {
      status: STATUS.JOIN_CLASS,
      joinEnabled: false,
      groupCode: '',
      errorMessage: null,
      highlight: -1,
      organizationQuery: '',
      loadingOrganizations: false,
      allOrganizationsLoaded: false,
      organizations: null,
      organization: null,
      teacherQuery: '',
      loadingTeachers: false,
      teachers: null,
      teacher: null,
      loadingGroups: false,
      groups: null,
    };

    this.childRefs = {
      scrollAreaOrganizations: React.createRef<ScrollableArea>(),
      scrollAreaTeachers: React.createRef<ScrollableArea>(),
      groupCode: React.createRef(),
      scrollAreaGroups: React.createRef<ScrollableArea>(),
    };
  }

  _blockResultMouseOverWhileScrolling: boolean;

  findGroupWithCode = debounce(code => {
    const showError = () => {
      if (code === this.state.groupCode) {
        const node = ReactDOM.findDOMNode(this.refs.groupCode);
        if (node instanceof HTMLElement) {
          node.blur();
        }
        this.setState({
          errorMessage: `Uh oh! We couldn't find a class matching this code.
          Please contact your teacher for your class code.`,
        });
      }
    };

    Group.fetchByCode(code)
      .then(group => {
        if (code === this.state.groupCode) {
          if (group && group.canJoin()) {
            this.setState({
              joinEnabled: true,
              groupCode: group.getCode(),
            });
          } else {
            this.setState({ joinEnabled: false });
            showError();
          }
        }
      }, showError)
      .catch(errorLogger('JoinGroupModal fetchByCode failed'));
  }, DEBOUNCE_DELAY);

  handleClickTeacher = (teacher: Teacher) => {
    if (teacher.isInvited()) {
      return;
    } else if (teacher.isInvitable()) {
      let subtext;
      if (teacher.isUser()) {
        subtext = 'Invite them to start using Remind.';
      } else if (teacher.isLead()) {
        subtext = 'Invite them to join Remind.';
      }

      const modal = (
        <AlertDialog
          title={`${teacher.getName()} doesn't have any classes on Remind.`}
          subtext={subtext}
          image={require('assets/images/book-pages.svg')}
          buttonText="Invite"
          onOkay={() => this.inviteTeacher(teacher)}
        />
      );

      mountModal(modal, this);
    }

    this.setState({ teacher }, this.handleToSelectClass);
  };

  handleFindSchoolInputChange = (event?: React.FormEvent<HTMLInputElement>) => {
    this.setState(
      {
        organizationQuery: (event && event.currentTarget.value) || '',
        loadingOrganizations: true,
        allOrganizationsLoaded: false,
      },
      this.loadOrganizations
    );
  };

  handleFindTeacherInputChange = (event?: React.FormEvent<HTMLInputElement>) => {
    this.setState(
      {
        teacherQuery: (event && event.currentTarget.value) || '',
        loadingTeachers: true,
      },
      this.loadTeachers
    );
  };

  handleInputKeyDown: KeyboardEventHandler = event => {
    let results: Organizations | Teachers | null = null;
    let type;
    if (this.state.status === STATUS.FIND_SCHOOL) {
      results = this.state.organizations;
      type = 'organization';
    } else if (this.state.status === STATUS.FIND_TEACHER) {
      results = this.state.teachers;
      type = 'teacher';
    }

    const code = event.keyCode;
    switch (code) {
      case KeyConstants.ENTER: {
        const searchItemNode = ReactDOM.findDOMNode(
          this.refs[`${type}-searchItem-${this.state.highlight}`]
        );

        if (searchItemNode instanceof HTMLElement) {
          searchItemNode.click();
        }
        break;
      }
      case KeyConstants.UP:
      case KeyConstants.DOWN: {
        const resultLength = results ? results.length : 0;
        let { highlight } = this.state;
        if (code === KeyConstants.UP) {
          highlight = highlight >= 0 ? highlight - 1 : resultLength - 1;
        } else {
          highlight = highlight < resultLength ? highlight + 1 : 0;
        }
        this.setState({ highlight });

        if (highlight >= 0 && highlight < resultLength) {
          const searchItemNode = ReactDOM.findDOMNode(this.refs[`${type}-searchItem-${highlight}`]);
          if (this.state.status === STATUS.FIND_SCHOOL) {
            const currentRef = this.childRefs.scrollAreaOrganizations.current;
            currentRef && currentRef.scrollIntoView(searchItemNode as Element);
          } else if (this.state.status === STATUS.FIND_TEACHER) {
            const currentRef = this.childRefs.scrollAreaTeachers.current;
            currentRef && currentRef.scrollIntoView(searchItemNode as Element);
          }

          this._blockResultMouseOverWhileScrolling = true;
        }
        break;
      }
      default:
        return;
    }
    event.preventDefault();
  };

  handleInvalidForm = () => {
    this.setState({ joinEnabled: false, errorMessage: null });
  };

  handleResultMouseOver = (index: number) => {
    if (this._blockResultMouseOverWhileScrolling) {
      this._blockResultMouseOverWhileScrolling = false;
      return;
    }

    if (this.state.highlight !== index) {
      this.setState({ highlight: index });
    }
  };

  handleScroll = throttle(() => {
    if (
      !this.state.loadingOrganizations &&
      this.isScrolledToBottom() &&
      !this.state.allOrganizationsLoaded
    ) {
      this.setState({ loadingOrganizations: true });
      this.loadMoreOrganizations()
        .then((organizations: Organizations) => {
          this.setState({
            loadingOrganizations: false,
            allOrganizationsLoaded: organizations.length < ORGANIZATIONS_PAGE_SIZE,
            organizations: this.state.organizations
              ? this.state.organizations.add(organizations.models || [])
              : organizations,
          });
        })
        .catch(errorLogger('JoinGroupModal loadMoreOrganizations failed'));
    }
  }, 100);

  handleSelectClass = () => {
    this.setState({ loadingGroups: true }, this.loadGroups);
  };

  handleToFindSchoolBackward = () => {
    this.setState({
      status: STATUS.FIND_SCHOOL,
      organization: null,
    });
  };

  handleToFindSchoolForward = () => {
    const switchToSearch = () => {
      this.setState(
        {
          status: STATUS.FIND_SCHOOL,
          highlight: -1,
          organizationQuery: '',
          loadingOrganizations: false,
          organizations: null,
          organization: null,
        },
        this.handleFindSchoolInputChange
      );
    };

    let user = CurrentUser.getUser();
    if (user.getRole() === 'student' && user.getBirthdate() === null) {
      const onComplete = () => {
        user = CurrentUser.getUser();
        if (user.isUnderage()) {
          ToastActions.showErrorToast('Search isn’t available for students under 13');
        } else if (user.getBirthdate() !== null) {
          switchToSearch();
        }
      };
      mountModal(<BirthdayInterruptModal onRequestHide={onComplete} />, this);
    } else {
      switchToSearch();
    }
  };

  handleToFindTeacherBackward = () => {
    this.setState({
      status: STATUS.FIND_TEACHER,
      teacher: null,
    });
  };

  handleToFindTeacherForward = () => {
    this.setState(
      {
        status: STATUS.FIND_TEACHER,
        highlight: -1,
        teacherQuery: '',
        loadingTeachers: false,
        teachers: null,
        teacher: null,
      },
      () => this.handleFindTeacherInputChange()
    );
  };

  handleToJoinClassBackward = () => {
    this.setState({ status: STATUS.JOIN_CLASS, groupCode: '', errorMessage: null });
  };

  handleToSelectClass = () => {
    this.setState(
      {
        status: STATUS.SELECT_CLASS,
        loadingGroups: false,
        groups: null,
      },
      this.handleSelectClass
    );
  };

  handleToRequestToJoin = (group: RequestToJoinGroup) => {
    this.setState({
      rtjGroup: group,
      status: STATUS.REQUEST_TO_JOIN_CLASS,
    });
  };

  handleValidForm = debounce(async () => {
    const { groupCode } = this.state;

    this.setState({ joinEnabled: false, errorMessage: null });

    if (!groupCode) {
      return;
    }

    const alreadySubscribed = await this.isAlreadySubscribed(groupCode);
    if (alreadySubscribed) {
      this.setState({
        errorMessage: 'You’ve already joined this class!',
      });
      return;
    }

    const group = await loadGQLUserGroupByCode(groupCode);
    const userId = CurrentUser.getUserId();
    if (group && group.type === 'owned') {
      this.setState({
        errorMessage:
          'You currently own this class. ' +
          'To receive copies of your messages, change your preferences in Notifications.',
      });
      return;
    }

    if (!this.state.groupCode) {
      return;
    }

    this.findGroupWithCode(this.state.groupCode);
  }, DEBOUNCE_DELAY);

  inviteTeacher = (teacher: Teacher) => {
    const onInvited = () => {
      teacher.setState('invited');
      this.forceUpdate(); // better than what was here
    };
    if (teacher.isUser()) {
      UserActions.requestForPublicGroups(teacher.id)
        .then(onInvited)
        .catch(errorLogger('JoinGroupModal requestForPublicGroups failed'));
    }
  };

  isAlreadySubscribed = async (code: string) => {
    const group = await loadGQLUserGroupByCode(code, true);
    const userId = CurrentUser.getUserId();
    return group && group.type === 'subscribed';
  };

  isScrolledToBottom = () => {
    const current = this.childRefs.scrollAreaOrganizations.current;
    return current ? current.isScrolledToBottom(100) : false;
  };

  joinGroup = async () => {
    const { groupCode } = this.state;
    if (isNil(groupCode)) {
      console.error('Did not get groupCode inside JoinGroupModal');
      ToastActions.showErrorToast(
        'Oops! Looks like we couldn’t find that group. Please try again.'
      );
      return;
    }

    const group = await loadNonV2GroupByCode(groupCode);
    if (group && group.requestToJoinEnabled && group.requestToJoinRequired) {
      this.handleToRequestToJoin(group);
    } else {
      GroupActions.subscribeToGroupWithCode(groupCode).then(
        group => {
          GroupActions.addToGroupsJoinedDuringSetup(group);
          ToastActions.showSuccessToast(`You’ve joined ${group.getName()}`);
          this.props.onRequestHide();
          this.props.onJoin(group);
        },
        error => {
          if (error.code === 'information_required') {
            // TODO model this via Flux so this component doesn't manage the route
            this.context.router.push(`/information_required/${groupCode}`);
          } else {
            const errorMessage = error.message || 'Error joining class.';
            ToastActions.showErrorToast(errorMessage);
            ErrorActions.serverError(error);
            console.warn('Join group modal failed to subscribe', error);
          }
        }
      );
    }
  };

  loadGroups = (): void => {
    if (isNil(this.state.teacher)) {
      console.error('this.state.teacher was undefined/null in JoinGroupModal');
      return;
    }

    Groups.find(this.state.teacher.id)
      .then(groups => {
        this.setState({
          loadingGroups: false,
          groups,
        });
      })
      .catch(() => {
        const modal = (
          <AlertDialog
            glyph="caution"
            glyphColor="lava"
            title="Sorry, you can't view any more teachers right now."
            onRequestHide={this.handleToFindTeacherBackward}
          />
        );
        mountModal(modal, this);
      });
  };

  loadMoreOrganizations = () => {
    const query = this.state.organizationQuery;
    const numOrganizations = this.state.organizations ? this.state.organizations.length : 0;
    const page = Math.floor(numOrganizations / ORGANIZATIONS_PAGE_SIZE) + 1;
    return Organizations.search(OrganizationType.School, query, page, ORGANIZATIONS_PAGE_SIZE);
  };

  loadOrganizations = debounce(() => {
    const query = this.state.organizationQuery;
    Organizations.search(OrganizationType.School, query)
      .then(organizations => {
        // Don't update if the query changed
        if (query !== this.state.organizationQuery) {
          return;
        }
        this.setState({
          loadingOrganizations: false,
          organizations,
        });
      })
      .catch(errorLogger('JoinGroupModal search failed'));
  }, DEBOUNCE_DELAY);

  loadTeachers = debounce(() => {
    const query = this.state.teacherQuery;
    const org = this.state.organization;

    if (isNil(org)) {
      console.error('organization was nil in loadTeachers from JoinGroupModal');
      return;
    }

    Teachers.getTeachersForOrganizationId(org.id, query)
      .then(teachers => {
        // Don't update if the query changed
        if (query !== this.state.teacherQuery) {
          return;
        }
        this.setState({
          loadingTeachers: false,
          teachers,
        });
      })
      .catch(() => {
        const modal = (
          <AlertDialog
            glyph="caution"
            glyphColor="lava"
            title="Sorry, you can't view any more schools right now."
            onRequestHide={this.handleToFindSchoolBackward}>
            <Link
              href={LinkConstants.SELECTING_SCHOOL}
              block
              target="_blank"
              className="JoinGroupModal-learnMore"
              eventElementName="JoinGroupModal-learnMore">
              Learn more
            </Link>
          </AlertDialog>
        );
        mountModal(modal, this);
      });
  }, DEBOUNCE_DELAY);

  reportTeacher = () => {
    const modal = <ReportTeacherSelectModal teacher={this.state.teacher} />;
    mountModal(modal, this);
  };

  subscribeToGroup = (group: Group) => {
    const markAsSubscribed = (updatedGroup: Group) => {
      const type = updatedGroup.getType();

      if (type === 'pending') {
        ToastActions.showSuccessToast(`You’ve requested to join ${updatedGroup.getName()}`);
      } else {
        ToastActions.showSuccessToast(`You’ve joined ${updatedGroup.getName()}`);
      }

      group.setState(type);
      this.forceUpdate(); // better than what was here
    };

    GroupActions.subscribeToGroup(group).then(markAsSubscribed, error => {
      if (error.code === 'information_required') {
        const modal = (
          <JoinInfoModal
            groupCode={group.getCodeOrError()}
            onDone={markAsSubscribed}
            onRequestHide={() => {}}
          />
        );
        mountModal(modal, this);
        return;
      }
      const errorMessage = error.message || 'Error joining class.';
      ToastActions.showErrorToast(errorMessage);
      console.warn('Join group modal failed to subscribe', error);
    });
  };

  unsubscribeFromGroup = (group: Group) => {
    const onLeave = () => {
      GroupActions.unsubscribeFromGroup(group)
        .then(() => {
          group.setState('available');
          this.forceUpdate(); // better than what was here
          ToastActions.showSuccessToast(`You’ve left ${group.getName()}`);
        })
        .catch(errorLogger('JoinGroupModal unsubscribeFromGroup failed'));
    };
    const modal = (
      <ConfirmDialog
        title="Leave this class?"
        subtext={`Once you leave, you will no longer receive messages from ${group.getName()}`}
        actionButtonText="Leave"
        cancelButtonText="Cancel"
        onConfirm={onLeave}
      />
    );
    mountModal(modal, this);
  };

  renderFindSchool = () => {
    const Wrapper = this.props.modal ? Dialog : DialogContent;

    return (
      <Wrapper
        key="find-school"
        {...this.props}
        size="small"
        className="JoinGroupModal"
        title="Select your school"
        subtext="First, find the school you attend."
        hidePreviousButton={false}
        onRequestPrevious={this.handleToJoinClassBackward}>
        <BoxBody divided full>
          <div className="JoinGroupModal-inputWrap">
            <Input
              autofocus
              glyph="search"
              key="findSchoolSearch"
              noBorder
              placeholder="Search for a school"
              size="large"
              type="text"
              value={this.state.organizationQuery}
              onChange={this.handleFindSchoolInputChange}
              onKeyDown={this.handleInputKeyDown}
            />
          </div>
          <ScrollableArea
            className="JoinGroupModal-list"
            ref="scrollAreaOrganizations"
            onScroll={this.handleScroll}
            useBodyChildrenHeight>
            {this.renderOrganizations()}
            {this.state.loadingOrganizations && this.renderLoadingIndicator()}
          </ScrollableArea>
        </BoxBody>
      </Wrapper>
    );
  };

  renderFindTeacher = () => {
    const Wrapper = this.props.modal ? Dialog : DialogContent;

    return (
      <Wrapper
        key="find-teacher"
        {...this.props}
        size="small"
        className="JoinGroupModal"
        title="Find your teacher"
        subtext={(this.state.organization && this.state.organization.getName()) || ''}
        hidePreviousButton={false}
        onRequestPrevious={this.handleToFindSchoolBackward}>
        <BoxBody divided full>
          <div className="JoinGroupModal-inputWrap">
            <Input
              autofocus
              glyph="search"
              noBorder
              placeholder="Search for a teacher"
              size="large"
              type="text"
              value={this.state.teacherQuery}
              onChange={this.handleFindTeacherInputChange}
              onKeyDown={this.handleInputKeyDown}
            />
          </div>
          <ScrollableArea
            className="JoinGroupModal-list"
            ref="scrollAreaTeachers"
            useBodyChildrenHeight>
            {this.renderTeachers()}
            {this.state.loadingTeachers && this.renderLoadingIndicator()}
          </ScrollableArea>
        </BoxBody>
      </Wrapper>
    );
  };

  renderGroups = () => {
    if (!this.state.groups) {
      return null;
    }
    return this.state.groups.map(group => {
      let join;

      if (group.isAvailable()) {
        if (group.isRequestToJoinEnabled()) {
          const avatarUrl = group.getAvatarUrl();
          const org = group.getOrganization();

          const translatedGroup = {
            className: group.getName(),
            code: group.getCodeOrError(),
            organization: org ? { name: org.getName() } : null,
            groupAvatar: avatarUrl ? { svg_url: avatarUrl } : null,
          };

          join = (
            <Button
              eventElementName="JoinGroupModal-requestToJoin"
              level="secondary"
              size="xsmall"
              weight="semibold"
              onClick={() => this.handleToRequestToJoin(translatedGroup)}>
              Join
            </Button>
          );
        } else {
          join = (
            <Button
              eventElementName="JoinGroupModal-join"
              level="secondary"
              size="xsmall"
              weight="semibold"
              onClick={() => this.subscribeToGroup(group)}>
              Join
            </Button>
          );
        }
      } else if (group.isSubscribed()) {
        const enabled = group.canLeave();

        join = (
          <Button
            eventElementName="JoinGroupModal-joined"
            size="xsmall"
            weight="normal"
            disabled={!enabled}
            onClick={() => enabled && this.unsubscribeFromGroup(group)}
            aria-label="Leave class">
            <Glyph name="check" />
            Joined
          </Button>
        );
      } else if (group.isPending()) {
        join = (
          <Mutation
            mutation={CANCEL_REQUEST}
            onCompleted={() => {
              ToastActions.showSuccessToast('Request to join canceled');
              this.loadGroups();
            }}
            onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
            {(
              cancelRequest: (input: { variables: cancelGroupMembershipRequestVariables }) => void
            ) => (
              <Button
                eventElementName="JoinGroupModal-requested"
                size="xsmall"
                weight="normal"
                onClick={() =>
                  cancelRequest({ variables: { input: { groupUuid: group.getUuid() } } })
                }
                aria-label="Cancel join request">
                <Glyph name="check" />
                Requested
              </Button>
            )}
          </Mutation>
        );
      }

      return (
        <div
          key={group.id}
          className={cx('JoinGroupModal-list-item', {
            'JoinGroupModal-list-item--hasAction': group.isAvailable() || group.isSubscribed(),
          })}>
          <MediaObject center figure="right" className="JoinGroupModal-list-item-body">
            <MediaObject center figure="left" gutter="xsmall">
              <GroupAvatar group={group} className="JoinGroupModal-list-item-avatar" />
              <Text size="xxsmall">
                <Text element="h3" truncate>
                  <GroupName group={group} />
                </Text>
                <Text color="eclipse">@{group.getCodeOrError()}</Text>
              </Text>
            </MediaObject>
            {join}
          </MediaObject>
        </div>
      );
    });
  };

  renderJoinClass = () => {
    // TODO: Manually implemented MediaObject
    // (waiting for fix: https://github.com/christianalfoni/formsy-react/issues/151)
    const Wrapper = this.props.modal ? Dialog : DialogContent;
    const user = CurrentUser.getUser();

    const label = (
      <Label htmlFor="groupCode">
        Enter class code
        <HelpIcon
          tooltipText={`
            This is the unique code you can use to join and receive messages from your class.
          `}
        />
      </Label>
    );

    const button = (
      <Button
        type="submit"
        id="JoinGroupModal-joinButton"
        size="small"
        disabled={!this.state.joinEnabled}
        data-test-selector="join-group-modal-submit">
        Join
      </Button>
    );

    return (
      <Wrapper
        key="join-class"
        {...this.props}
        className="JoinGroupModal"
        title="Join a class"
        size="small">
        <BoxBody divided>
          <form
            onSubmit={e => {
              e.preventDefault();
              this.joinGroup();
            }}>
            <FormElement
              data-test="join-group-code-field"
              label={label}
              manualError={this.state.errorMessage}
              ref="groupCode"
              onValidChange={e =>
                this.setState({ groupCode: e.target.value }, this.handleValidForm)
              }
              onInvalidChange={() => this.setState({ groupCode: '' }, this.handleInvalidForm)}
              validate={e => {
                const { value } = e.target;
                assertions.lengthGreaterThanOrEqualTo(
                  value,
                  3,
                  'The code must be at least 3 characters long.'
                );
                assertions.lengthLesserThanOrEqualTo(
                  value,
                  10,
                  'The code cannot be over 10 characters long.'
                );
              }}
              appendedButton={button}
              element={PrependedTextInput}
              elementProps={{
                prepend: '@',
                autofocus: true,
                name: 'groupCode',
              }}
            />
          </form>
          {(user.getCountryCode() === 'US' || user.getCountryCode() === 'CA') &&
            !user.isUnderage() && (
              <Button
                className="JoinGroupModal-search"
                eventElementName="JoinGroupModal-search"
                level="text"
                weight="semibold"
                color="brand"
                onClick={this.handleToFindSchoolForward}>
                <Glyph name="search" />
                <span>Search for your class instead</span>
              </Button>
            )}
        </BoxBody>
        {this.props.footer}
      </Wrapper>
    );
  };

  renderLoadingIndicator = () => {
    return <LoadingIndicator height={100} size="small" />;
  };

  renderNotFound = (message: string) => {
    return (
      <div className="JoinGroupModal-list-item--notFound JoinGroupModal-list-item">
        <div className="JoinGroupModal-list-item--notFound-body JoinGroupModal-list-item-body">
          <Text align="center" element="div" className="JoinGroupModal-list-item--notFound-inner">
            <Text element="h3" size="small" weight="semibold">
              {message}
            </Text>
            <Text color="thunder" size="xxsmall">
              Please try again or join using the class code from your teacher.
            </Text>
          </Text>
        </div>
      </div>
    );
  };

  renderOrganizations = () => {
    if (!this.state.organizations) {
      return null;
    }
    if (this.state.organizations.length === 0 && !this.state.loadingOrganizations) {
      if (this.state.organizationQuery.length === 0) {
        return null;
      }
      return this.renderNotFound('School not found');
    }

    return this.state.organizations.map((organization, index) => {
      return (
        <div
          className={cx('JoinGroupModal-list-item', {
            'JoinGroupModal-list-item--highlight': this.state.highlight === index,
          })}
          ref={`organization-searchItem-${index}`}
          onClick={() => this.setState({ organization }, this.handleToFindTeacherForward)}
          onMouseOver={() => this.handleResultMouseOver(index)}
          key={organization.id}>
          <div className="JoinGroupModal-list-item-body">
            <Text size="xxsmall" className="JoinGroupModal-list-item-text">
              <Text truncate>{organization.getName()}</Text>
              <Text color="eclipse">{organization.getFormattedAddress()}</Text>
            </Text>
          </div>
        </div>
      );
    });
  };

  renderSelectClass = () => {
    const Wrapper = this.props.modal ? Dialog : DialogContent;
    return (
      <Wrapper
        key="select-class"
        {...this.props}
        size="small"
        className="JoinGroupModal"
        title="Select a class"
        subtext={`Select one or more of ${this.state.teacher &&
          this.state.teacher.getName()}'s classes below.`}
        hidePreviousButton={false}
        onRequestPrevious={this.handleToFindTeacherBackward}>
        <BoxBody divided>
          <Row>
            <ScrollableArea
              className="JoinGroupModal-list JoinGroupModal-list--full"
              ref="scrollAreaGroups"
              showShadows
              useBodyChildrenHeight>
              {this.renderGroups()}
              {this.state.loadingGroups && this.renderLoadingIndicator()}
            </ScrollableArea>
          </Row>
          <Buttons axis="y">
            <Button
              className="JoinGroupModal-done"
              eventElementName="JoinGroupModal-done"
              onClick={this.props.onRequestHide}>
              Done
            </Button>
            <Link color="thunder" onClick={this.reportTeacher}>
              <Glyph name="flag" size="medium" />
              Report this person
            </Link>
          </Buttons>
        </BoxBody>
      </Wrapper>
    );
  };

  renderTeachers = () => {
    if (!this.state.teachers) {
      return null;
    }
    if (this.state.teachers.length === 0 && !this.state.loadingTeachers) {
      return this.renderNotFound('Teacher not found');
    }
    return this.state.teachers.map((teacher, index) => {
      let invite;

      if (teacher.isInvitable()) {
        invite = (
          <Button
            level="secondary"
            size="xsmall"
            weight="normal"
            onClick={event => {
              event.stopPropagation();
              this.inviteTeacher(teacher);
            }}>
            Invite
          </Button>
        );
      } else if (teacher.isInvited()) {
        invite = <StatusLabel>Invited</StatusLabel>;
      }

      return (
        <div
          className={cx({
            'JoinGroupModal-list-item': true,
            'JoinGroupModal-list-item--hasAction': teacher.isInvitable(),
            'JoinGroupModal-list-item--highlight': this.state.highlight === index,
            'JoinGroupModal-list-item--disabled': teacher.isInvited(),
          })}
          ref={`teacher-searchItem-${index}`}
          onClick={() => this.handleClickTeacher(teacher)}
          onMouseOver={() => this.handleResultMouseOver(index)}
          key={teacher.id}>
          <div className="JoinGroupModal-list-item-body">
            <MediaObject figure="right" center>
              <Text size="xxsmall">
                <Text element="h3" truncate>
                  <NameAndSignatureQuery
                    displayName={teacher.getName()}
                    fullName={teacher.getFullName()}
                    query={this.state.teacherQuery}
                  />
                </Text>
                <Text color="eclipse" truncate>
                  {teacher.getPreview()}
                </Text>
              </Text>
              {invite}
            </MediaObject>
          </div>
        </div>
      );
    });
  };

  render() {
    // XXX antipattern. these should each be separate components
    const body = {
      [STATUS.JOIN_CLASS]: this.renderJoinClass,
      [STATUS.FIND_SCHOOL]: this.renderFindSchool,
      [STATUS.FIND_TEACHER]: this.renderFindTeacher,
      [STATUS.SELECT_CLASS]: this.renderSelectClass,
      [STATUS.REQUEST_TO_JOIN_CLASS]: () => {
        const { rtjGroup } = this.state;
        const Wrapper = this.props.modal ? Dialog : DialogContent;

        if (!rtjGroup) {
          console.error(
            'rtjGroup was not defined before needing it in request to join enabled class'
          );
          ToastActions.showErrorToast(
            'Something went wrong trying to join the class, please try again later.'
          );
          return;
        }

        return (
          <Wrapper
            key="join-request-to-join"
            {...this.props}
            className="JoinGroupModal"
            title="Request to join class"
            size="small">
            <BoxBody>
              <JoinGroupModalRequestToJoin
                className={rtjGroup.className}
                groupCode={rtjGroup.code}
                schoolName={rtjGroup.organization && rtjGroup.organization.name}
                onSubmit={() => {
                  // Updating user attributes locally for the sign-up process
                  UserActions.updateLocal({
                    needs: { groups: false },
                  });

                  this.props.onRequestHide();
                  this.context.router.push(getRedirectLocationAfterGroupJoin(rtjGroup.code));
                }}
                onCancel={this.props.onRequestHide}
                groupAvatar={
                  <GroupAvatar
                    group={{
                      groupAvatar: rtjGroup.groupAvatar ? rtjGroup.groupAvatar : { svg_url: '' },
                    }}
                  />
                }
              />
            </BoxBody>
          </Wrapper>
        );
      },
    }[this.state.status]();
    return body;
  }
}

export default JoinGroupModal;
